import { render, staticRenderFns } from "./IconSortDown.vue?vue&type=template&id=4440dfa7&"
import script from "./IconSortDown.vue?vue&type=script&lang=js&"
export * from "./IconSortDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports